import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

const Footer = () => {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();

  const A = "https://customer-assets.emergentagent.com/job_web-editor-45/artifacts";
  const sponsors = [
    { name: "more-wins", src: `${A}/qyvpek1i_Bildschirmfoto%202024-04-20%20um%2022.31.32.png`, cls: "h-24 md:h-28" },
    { name: "trackman", src: `${A}/rf0809s9_trackman-logo-png_seeklogo-572065.png`, cls: "h-9 md:h-11" },
    { name: "upgame", src: `${A}/l7bmrsnc_logo-dark.png.webp`, cls: "h-14 md:h-16" },
    { name: "titleist", src: `${A}/q82x8e6h_1274292_titleist_450.png`, cls: "h-16 md:h-24" },
  ];

  const navLinks = [
    { to: "/", label: t.nav.home },
    { to: "/trainer", label: t.nav.trainer },
    { to: "/kurse", label: t.nav.kurse },
    { to: "/einzeltraining", label: t.nav.einzeltraining },
    { to: "/onlinecoaching", label: t.nav.onlinecoaching },
    { to: "/golfclub", label: t.nav.golfclub },
  ];

  return (
    <footer data-testid="footer" className="relative z-[2] bg-[#050505] border-t border-white/10 pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-6">
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tight leading-[1.05] text-white whitespace-nowrap">
              GOLFCOACHING<span className="text-[#ff0033]">.</span>ACADEMY
            </h2>
            <p className="font-heading text-2xl md:text-3xl uppercase tracking-tight text-white leading-[1.05] mt-1">
              Wendlingen
            </p>
            <p className="font-mono-lab text-xs tracking-[0.25em] text-[#ff0033] uppercase mt-4">
              {t.footer.poweredBy}
            </p>
            <p className="text-neutral-400 mt-6 max-w-md text-sm md:text-base">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono-lab text-xs tracking-[0.2em] text-neutral-500 uppercase mb-5">
              {t.footer.nav}
            </p>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-neutral-300 hover:text-[#ff0033] transition-colors text-sm uppercase tracking-wide font-mono-lab"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono-lab text-xs tracking-[0.2em] text-neutral-500 uppercase mb-5">
              {t.footer.legal}
            </p>
            <ul className="space-y-3">
              <li>
                <Link to="/kontakt" className="text-neutral-300 hover:text-[#ff0033] transition-colors text-sm uppercase tracking-wide font-mono-lab">
                  {t.nav.kontakt}
                </Link>
              </li>
              <li>
                <Link to="/impressum" className="text-neutral-300 hover:text-[#ff0033] transition-colors text-sm uppercase tracking-wide font-mono-lab">
                  {t.nav.impressum}
                </Link>
              </li>
              <li>
                <Link to="/agb" data-testid="footer-agb-link" className="text-neutral-300 hover:text-[#ff0033] transition-colors text-sm uppercase tracking-wide font-mono-lab">
                  {lang === "en" ? "Terms & Legal" : "AGB & Recht"}
                </Link>
              </li>
              <li>
                <a href="https://www.golfcoaching.online" target="_blank" rel="noreferrer" className="text-neutral-300 hover:text-[#ff0033] transition-colors text-sm uppercase tracking-wide font-mono-lab">
                  golfcoaching.online
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Sponsoren / Partner Banner */}
        <div className="border-t border-white/10 pt-10 pb-2" data-testid="sponsors-banner">
          <p className="font-mono-lab text-xs tracking-[0.2em] text-neutral-500 uppercase text-center mb-8">
            {t.footer.sponsors}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 md:gap-x-16">
            {sponsors.map((s) => (
              <img
                key={s.name}
                src={s.src}
                alt={s.name}
                data-testid={`sponsor-${s.name}`}
                className={`${s.cls} w-auto object-contain opacity-70 hover:opacity-100 transition-opacity duration-300`}
              />
            ))}
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-mono-lab text-xs text-neutral-600 tracking-wide">
            © {year} GOLFCOACHING ACADEMY WENDLINGEN. {t.footer.rights}
          </p>
          <p className="font-mono-lab text-xs text-neutral-600 tracking-wide">
            www.golfcoaching-academy.online
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
